<template>
  <e-chart
    :options="chartOptions"
    @click="handleClickEvent"
    autoresize
    class="h-100"
  ></e-chart>
</template>

<script>
import colorPalette from '@/xvisor/constants/colorPalette';
import flowGraphMixin from '@/xvisor/components/infra/infraNoTrafficMixin';
import themeStyle from '@/xvisor/utilities/themeStyle';

export default {
  mixins: [flowGraphMixin],
  props: {
    series: {
      type: Object,
      required: true,
    },
    categoryNames: {
      type: Array,
      required: true,
    },
  },
  computed: {
    chartData() {
      return {
        nodes: this.series.map((node) => (
          this.formattedNode(
            node,
          )
        )),
        links: [],
        categories: this.categoryNames.map((category) => ({ name: category })),
      };
    },
    chartOptions() {
      const options = JSON.parse(JSON.stringify(this.chartOptionsTemplate));
      options.series[0].data = this.chartData.nodes;
      options.series[0].links = this.chartData.links;
      options.series[0].categories = this.chartData.categories;
      options.legend[0].textStyle.color = this.toggleColor;
      return options;
    },
    toggleColor() {
      return themeStyle.styleToggle(colorPalette.black, colorPalette.white);
    },
  },
  methods: {
    handleClickEvent(event) {
      if (('category' in event.data) && ('id' in event.data)) {
        if (event.data.category === 'network') {
          const infra = {
            // TODO: Currently the type of the node is hard coded to be 'router'.
            //  We might need to change the endpoint to contain this information.
            type: 'router',
            ip: event.data.id,
          };
          this.$emit('infra-click', infra);
        }
        if (event.data.category === 'endhost') {
          const xtend = {
            id: event.data.id,
          };
          this.$emit('xtend-click', xtend);
        }
      }
    },
  },
};
</script>

<style scoped>
.echarts {
  width: 100% !important;
  height: 100vh !important;
}
</style>
